var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrashDelete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Trash-delete"
  }, /*#__PURE__*/React.createElement("path", {
    id: "BG",
    opacity: 0.4,
    d: "M6.53125 6.92969V17.9997C6.53125 19.2397 7.54125 20.2497 8.78125 20.2497H15.2312C16.4712 20.2497 17.4812 19.2397 17.4812 17.9997V6.92969H6.53125ZM10.8912 16.2797C10.8912 16.6997 10.5512 17.0297 10.1412 17.0297C9.72124 17.0297 9.39124 16.6997 9.39124 16.2797V10.2797C9.39124 9.86969 9.72124 9.52969 10.1412 9.52969C10.5512 9.52969 10.8912 9.86969 10.8912 10.2797V16.2797ZM14.8912 16.2797C14.8912 16.6997 14.5512 17.0297 14.1412 17.0297C13.7212 17.0297 13.3912 16.6997 13.3912 16.2797V10.2797C13.3912 9.86969 13.7212 9.52969 14.1412 9.52969C14.5512 9.52969 14.8912 9.86969 14.8912 10.2797V16.2797Z",
    fill: "#D58B0E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4 6.18H20M10.14 10.29V16.29M14.14 10.29V16.29M18.23 18C18.23 19.66 16.89 21 15.23 21H8.79004C7.13004 21 5.79004 19.66 5.79004 18V6.18H18.23V18ZM13.17 3H10.83C9.85996 3 9.06995 3.79 9.06995 4.76V6.17H14.9301V4.76C14.9301 3.79 14.14 3 13.17 3Z",
    stroke: "#D58B0E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashDelete);
export default __webpack_public_path__ + "static/media/TrashDelete.0c166081ab2cefc82082a400762fd823.svg";
export { ForwardRef as ReactComponent };